window.addEventListener("load", () => {
  setTimeout(initScrollStory, 200);
});

document.addEventListener("shopify:section:load", () => {
  setTimeout(initScrollStory, 200);
});

function initScrollStory() {
  gsap.registerPlugin(ScrollTrigger);
  ScrollTrigger.getAll().forEach(trigger => trigger.kill());

  const track = document.querySelector(".horizontal-track");
  if (!track) return;

  // 1. CREATE THE MASTER TIMELINE
  let tl = gsap.timeline({
    scrollTrigger: {
      trigger: ".scroll-story",
      start: "top top", // CRITICAL FIX: Locks securely to the top of the browser
      end: () => `+=${track.scrollWidth + (window.innerHeight * 3)}`, 
      pin: true,
      scrub: 1,
      invalidateOnRefresh: true
    }
  });

  // PHASE 1: Image Panel slides in
  tl.fromTo(".story-split", 
    { xPercent: 100 }, 
    { xPercent: 0, duration: 1.5, ease: "power1.inOut" } 
  )
  
  // PHASE 1.5: Image scale down
  .to(".story-image img", { 
    scale: 1, 
    duration: 1, 
    ease: "none" 
  })
  
  // PHASE 2: "THE PUSH" - Products push Image
  .fromTo(".horizontal-section", 
    { xPercent: 100 }, 
    { xPercent: 0, duration: 1.5, ease: "power1.inOut" },
    "pushPanel" 
  )
  .to(".story-split", 
    { xPercent: -100, duration: 1.5, ease: "power1.inOut" }, 
    "pushPanel" 
  )

  // PHASE 3: Track scroll
  .fromTo(track, 
    { x: 0 }, 
    { 
      x: () => -(track.scrollWidth - window.innerWidth + 100), 
      duration: 2.5, 
      ease: "none" 
    }
  );

  document.querySelector('.horizontal-section').style.pointerEvents = 'auto';

  const observer = new ResizeObserver(() => {
    ScrollTrigger.refresh();
  });
  observer.observe(track);
}